(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"]) return;
  try {
    
  window.addEventListener('DOMContentLoaded', function(event) {



//collection sort
    var test = new simpleSort('.ss-box', 'div.product_sort');

    $('#ss-sort').on('click', function() {
      $(this).addClass('active').siblings().removeClass('active');
        // toggle sort
        if(test.order === 'desc') {
            test.sort('data-price', 'asc');
            $(this).find('i').removeClass('fa-arrow-down').addClass('fa-arrow-up');
        } else {
            test.sort('data-price', 'desc');
            $(this).find('i').addClass('fa-arrow-down').removeClass('fa-arrow-up');
        }

    });
    $('#ss-lm').on('click', function() {
        $(this).addClass('active').siblings().removeClass('active');
        if(test.order === 'desc') {
            test.sort('data-lm', 'asc');
        } else {
            test.sort('data-lm', 'desc');
        }
    });
    $('#ss-m').on('click', function() {
        $(this).addClass('active').siblings().removeClass('active');
        if(test.order === 'desc') {
            test.sort('data-m', 'asc');
        } else {
            test.sort('data-m', 'desc');
        }
    });
  $('#ss-h').on('click', function() {
        $(this).addClass('active').siblings().removeClass('active');
        if(test.order === 'desc') {
            test.sort('data-h', 'asc');
        } else {
            test.sort('data-h', 'desc');
        }
    });
  $('#ss-r').on('click', function() {
        $(this).addClass('active').siblings().removeClass('active');
        if(test.order === 'desc') {
            test.sort('data-r', 'asc');
        } else {
            test.sort('data-r', 'desc');
        }
});






function arrayFromDivs(selector) {
  var result = []
  var selected = document.querySelectorAll(selector)
  if (selected) {
    var l = selected.length,
      i = 0
    for (; i < l; ++i) {
      result.push(selected[i])
    }
  }
  return result
}


function ulLiReselector(hash){
  var ul = document.querySelector('.nav-sort-orders')
  var lis=ul.querySelectorAll('li')
  var l = lis.length,
      i = 0
  for (; i < l; ++i) {
    var li = lis[i]
    li.classList.remove('selected')
    var ca=li.querySelector('a')
    var href=(ca?ca.href:'').replace(/^.+(#[a-z])/,'$1')
    if (href===hash) li.classList.add('selected')
  }
}



function sortDivs(arr, field) {
  function _sort0(a, b, field) {
    return parseFloat(a.dataset[field]) < parseFloat(b.dataset[field]) ? 1 : -1
  }

  function _sort1(a, b) {
    return _sort0(a, b, field)
  }
  if (arr.length > 0) {
    var sorted = arr.sort(_sort1)
    var orderedList = document.querySelector('div.grid-uniform:nth-child(3)')
    var l = sorted.length,
      i = 0
    for (; i < l; ++i) {
      var div = sorted[i]
      if (div.dataset[field]==0) {
        var ca=div.querySelector('a')
        var ca2=ca?ca.href:''
        console.log(div.dataset)
        console.log(ca2)
      }
      orderedList.appendChild(div)
    }
  } else {
    throw ('the selctor is not working')
  }

  ulLiReselector( location.hash )
  var _group=document.querySelector('.filter-group.filter-group-sort-orders')
  if (_group) _group.classList.add('pt-group-expanded')
}





function createLi(link, title){
  var _li=document.createElement('li')
  _li.setAttribute('class','active')
  var _div=document.createElement('div')
  _div.setAttribute('class',"collection-name")
  var _a=document.createElement('a')
  _a.href=link
  _a.setAttribute('title',title)
  var _tn = document.createTextNode(' '+title)
  var _i=document.createElement('i')
  _i.setAttribute('class','check-icon')
  _a.appendChild(_i)
  _a.appendChild(_tn)
  _div.appendChild(_a)
  _li.appendChild(_div)
    return(_li)
}

function extendSort(selector,link,title){
  var de=document.querySelector(selector)
  var li=createLi(link,title)
  de.appendChild(li)
}

extendSort('.nav-sort-orders','#lumens','Lumens')
extendSort('.nav-sort-orders','#hours','Hours')
extendSort('.nav-sort-orders','#range','Range')
extendSort('.nav-sort-orders','#weight','Weight')
extendSort('.nav-sort-orders','#rechargeable','Rechargeable')
extendSort('.nav-sort-orders','#color','Multicolor')

function hashHandler(){
  console.log(location.hash)
  var target = arrayFromDivs('.grid-link__container .grid__item')
  if (location.hash==='#hours') sortDivs(target, 'h')
  if (location.hash==='#lumens') sortDivs(target, 'lm')
  if (location.hash==='#range') sortDivs(target, 'm')
  if (location.hash==='#weight') sortDivs(target, 'w')
  if (location.hash==='#length') sortDivs(target, 'length')
  if (location.hash==='#rechargeable') sortDivs(target, 'rechargeable')
  if (location.hash==='#color') sortDivs(target, 'color')
  if (location.hash==='#new') sortDivs(target, 'new')
  if (location.hash==='#available') sortDivs(target, 'sold')


}
                 
function loadMore(pageNum, toLoad) {
  fetch("?page=" + pageNum)
    .then(function (res) {
      return res.text();
    })
    .then(function (html) {
      var domparser = new DOMParser();
      var doc = domparser.parseFromString(html, "text/html");
      var dom = doc.querySelectorAll(
        ".filter-and-products > div.grid-uniform > div"
      );
      var firstItemReturned= dom[0].innerHTML.match(/there are no products in this collection/)
      console.warn(firstItemReturned)
      if (firstItemReturned) current=toLoad
      return firstItemReturned ? [] : dom; // nothing to add
    })
    .then(function (page2) {
      var domList = document.querySelector(
        ".filter-and-products > div.grid-uniform"
      );
      var i = 0,
        l = page2.length;
      if (!l) {
        var paginator=document.querySelector(".pagination-custom")
		if (paginator) paginator.remove();
        hashHandler();// sort when loaded
		return
      }
                 

      for (; i < l; ++i) {
        domList.appendChild(page2[i]);
      }

      var current = document.querySelectorAll(
        ".filter-and-products > div.grid-uniform > div"
      ).length;

      if (current === toLoad) {
        var paginator=document.querySelector(".pagination-custom")
		if (paginator) paginator.remove();
        hashHandler();// sort when loaded
      } else {
        loadMore(++pageNum, toLoad);
      }
    });
}



function checkIfLoadMore() {
  var currentProducts = document.querySelectorAll( ".filter-and-products > div.grid-uniform > div");
  if (typeof(fetch)==="function" && currentProducts && window.collection && currentProducts.length < window.collection.size)
  {
    console.log(currentProducts.length)
    console.log(window.collection.size)
    loadMore(2,window.collection.size)
  } else {
    hashHandler()
  }
}
window.addEventListener('hashchange' ,  hashHandler , false)


checkIfLoadMore()

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare-table"]) return;
  try {
    
// fetch polyfill
self.fetch||(self.fetch=function(b,d){return d=d||{},new Promise(function(e,f){var g=new XMLHttpRequest,h=[],j=[],k={},i=function(){return{ok:2==(0|g.status/100),statusText:g.statusText,status:g.status,url:g.responseURL,text:function text(){return Promise.resolve(g.responseText)},json:function json(){return Promise.resolve(JSON.parse(g.responseText))},blob:function blob(){return Promise.resolve(new Blob([g.response]))},clone:i,headers:{keys:function keys(){return h},entries:function entries(){return j},get:function get(a){return k[a.toLowerCase()]},has:function has(a){return a.toLowerCase()in k}}}};for(var a in g.open(d.method||"get",b,!0),g.onload=function(){g.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm,function(a,b,c){h.push(b=b.toLowerCase()),j.push([b,c]),k[b]=k[b]?k[b]+","+c:c}),e(i())},g.onerror=f,g.withCredentials="include"==d.credentials,d.headers)g.setRequestHeader(a,d.headers[a]);g.send(d.body||null)})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-the-box"]) return;
  try {
    
(function(window) {


document.querySelector('#AddToCartForm').addEventListener('click', function (evt) {
    window.setTimeout(function () {

        var _variant = document.querySelector('#productSelect').value
        var _classes = document.querySelectorAll('.delivery--text .box-variant')
        var l = _classes.length,
            i = 0
        for (; i < l; i++) {
            var current = _classes[i]
            
            if (current.classList.contains('box-variant-' + _variant)) {
                current.classList.remove('visually-hidden')
                // show
            } else {
                // hide
                current.classList.add('visually-hidden')
            }
        }

        console.log(evt);
        console.log('click');
        console.log(_variant)
    }, 500)
    return false
}, false)

}(window));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["insta"]) return;
  try {
    
var api1Url =
  "https://api.instagram.com/v1/users/self/media/recent/?access_token=244835180.1677ed0.e35f93c5ca2b4fe1b002c08386255640&count=" +
  instaSettings.images;
console.log(api1Url)

  function renderResults(p,flag) {
    if (!flag) {
    p.timestamp= new Date()
      sessionStorage.setItem("instaJson", JSON.stringify(p));
    }

  var a = p.data;

  var b = function(c) {
    return {
      image: c.images.standard_resolution,
      caption: c.caption.text,
      link: c.link
    };
  };

  var c = [];

  for (var d = 0; d < a.length; d++) {
    c.push(b(a[d], d, a));
  }

  var f = c;

  var g = function(h) {
    var a = document.createElement("li");
    var b = document.createElement("p");
    var c = document.createElement("div");
    var d = document.createElement("a");
    d.setAttribute("href", h.link);
    d.setAttribute("class", "insta-square");
    c.setAttribute("style", "background-image: url( " + h.image.url + ");");
    var e = document.createTextNode(h.caption);
    b.appendChild(e);
    d.appendChild(c);
    d.appendChild(b);
    a.appendChild(d);
    return a;
  };

  var h = [];

  for (var i = 0; i < f.length; i++) {
    h.push(g(f[i], i, f));
  }

  var k = document.createElement("ul");
  var l = h;

  var m = function(c) {
    k.appendChild(c);
  };

  for (var n = 0; n < l.length; n++) {
    m(l[n], n, l);
  }


  document.querySelector("#IGGGallery").appendChild(k);
}

function getJson() {
    if ("function" === typeof jQuery) {
        $.get(api1Url, renderResults, "jsonp");
    } else {
        console.error("jquery is not loaded ?");
        fetch(api1Url).then(renderResults);
    }
}

function igStart() {
    console.log("insta start");
    var b = sessionStorage.getItem("instaJson");
    if (b) {
        var storedJson = JSON.parse(b)
        var storedDate = new Date(storedJson.timestamp)
        var timeDiff = Math.round(((new Date()) - storedDate) / (1000 * 60 * 60))
        console.log(storedJson);
        console.log(storedDate);
        console.log(timeDiff);
        if (timeDiff > 1) {
            getJson()
        } else {
            renderResults(JSON.parse(b), 1);
        }

    } else {
        getJson()
    }
}

igStart();






  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-comparison-chart"]) return;
  try {
    
// fetch polyfill
self.fetch||(self.fetch=function(b,d){return d=d||{},new Promise(function(e,f){var g=new XMLHttpRequest,h=[],j=[],k={},i=function(){return{ok:2==(0|g.status/100),statusText:g.statusText,status:g.status,url:g.responseURL,text:function text(){return Promise.resolve(g.responseText)},json:function json(){return Promise.resolve(JSON.parse(g.responseText))},blob:function blob(){return Promise.resolve(new Blob([g.response]))},clone:i,headers:{keys:function keys(){return h},entries:function entries(){return j},get:function get(a){return k[a.toLowerCase()]},has:function has(a){return a.toLowerCase()in k}}}};for(var a in g.open(d.method||"get",b,!0),g.onload=function(){g.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm,function(a,b,c){h.push(b=b.toLowerCase()),j.push([b,c]),k[b]=k[b]?k[b]+","+c:c}),e(i())},g.onerror=f,g.withCredentials="include"==d.credentials,d.headers)g.setRequestHeader(a,d.headers[a]);g.send(d.body||null)})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product--gallery"]) return;
  try {
    

var SETTINGS = {
    navBarTravelling: false,
    navBarDirection: "",
    navBarTravelDistance: 400
}

var pnProductNav = document.querySelector('.pn-ProductNav')
var pnProductNavContents = document.querySelector(".pn-ProductNav_Contents");
var pnAdvancerLeft  = document.querySelector('button.pn-Advancer.pn-Advancer_Left')
var pnAdvancerRight = document.querySelector('button.pn-Advancer.pn-Advancer_Right')

function debounce( f, ms, ctx, immediate ) {
  var ts, fn;
  var timeout = null;
  var args;

  fn = function () {
    ctx = ctx || this;
    args = arguments;
    ts = now();

    var later = function () {
      var diff = now() - ts;

      if ( diff < ms ) {
        timeout = setTimeout( later, ms - diff );
        return;
      }
      timeout = null;

      if ( !immediate ) {
        f.apply( ctx, args );
      }
    };

    if ( timeout === null ) {
      if ( immediate ) {
        f.apply( ctx, args );
      }
      timeout = setTimeout( later, ms );
    }
  };

  fn.cancel = function () {
    clearTimeout( timeout );
    timeout = null; // properly clear the timeout so the next call to fn works as expected
  };

  return fn;
};


function determineOverflow(content, container) {
    if (content && container) {
        var containerMetrics = container.getBoundingClientRect();
        var containerMetricsRight = Math.floor(containerMetrics.right);
        var containerMetricsLeft = Math.floor(containerMetrics.left);
        var contentMetrics = content.getBoundingClientRect();
        var contentMetricsRight = Math.floor(contentMetrics.right);
        var contentMetricsLeft = Math.floor(contentMetrics.left);
        if (containerMetricsLeft > contentMetricsLeft && containerMetricsRight < contentMetricsRight) {
            return "both";
        } else if (contentMetricsLeft < containerMetricsLeft) {
            return "left";
        } else if (contentMetricsRight > containerMetricsRight) {
            return "right";
        } else {
            return "none";
        }
    } else {
        console.error("content or container can't be selected!!!")
    }
}


function advanceTo(direction) {
    direction=direction||'left'
	console.log(direction)
    console.log('traveling:'+SETTINGS.navBarTravelling)
    // If in the middle of a move return

    if (SETTINGS.navBarTravelling === true) {
        return;
    }
	console.log('handling click')

    var overflow=determineOverflow(pnProductNavContents, pnProductNav)
	console.log(overflow)


    // If we have content overflowing both sides or on the left
    if (overflow === direction || overflow === "both") {
		console.log('ovf== direction')
        // Find how far this panel has been scrolled


if (direction==='left'){
		var availableScroll = pnProductNav.scrollLeft
} else {
		var navBarRightEdge = pnProductNavContents.getBoundingClientRect().right;
        var navBarScrollerRightEdge = pnProductNav.getBoundingClientRect().right;
        var availableScroll = Math.floor(navBarRightEdge - navBarScrollerRightEdge);
}

        // If the space available is less than two lots of our desired distance, just move the whole amount
        // otherwise, move by the amount in the settings
		console.log(availableScroll)
        var sign=direction==='left'?'':'- '



        if (availableScroll < SETTINGS.navBarTravelDistance * 2) {
console.log('smaller')
		var transform = "translateX("+sign + availableScroll + "px)";
        } else {
console.log('normal')
		var transform = "translateX("+sign + SETTINGS.navBarTravelDistance + "px)";
        }
        pnProductNavContents.style = 'transform:'+transform+';';
		//pnProductNavContents.style.transform = transform;


        // We do want a transition (this is set in CSS) when moving so remove the class that would prevent that
        pnProductNavContents.classList.remove("pn-ProductNav_Contents-no-transition");
        // Update our settings
        SETTINGS.navBarTravelDirection = direction;
        SETTINGS.navBarTravelling = true;

    }
    // Now update the attribute in the DOM
    pnProductNav.setAttribute("data-overflowing", determineOverflow(pnProductNavContents, pnProductNav));
}



pnAdvancerLeft.addEventListener("click", function(){
	advanceTo('left')
} );
pnAdvancerRight.addEventListener("click", function(){
	advanceTo('right')
} );



function handleScrollIndicators() {
    // Handle the scroll of the horizontal container
    var last_known_scroll_position = 0;
    var ticking = false;

    function updateScrollButtons(scroll_pos) {
        pnProductNav.setAttribute("data-overflowing", determineOverflow(pnProductNavContents, pnProductNav));
    }
    pnProductNav.addEventListener("scroll", function () {
        last_known_scroll_position = window.scrollY;
        if (!ticking) {
            window.requestAnimationFrame(function () {
                updateScrollButtons(last_known_scroll_position);
                ticking = false;
            });
        }
        ticking = true;
    });

    updateScrollButtons()
}
handleScrollIndicators()





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-now2"] && !Shopify.designMode) return;
  try {
    
try {
    var constday=86400000
    var form = document.querySelector('#mc--form')
    var closedAt = new Date(localStorage.getItem('mailChimpClosedAt2')) || new Date()
    var closedSince = Math.floor(((new Date()) - closedAt )/constday)
    var rightTime=closedSince>subscribeAgain


    function subscribeHandler(event) {
      //console.log(' subscribeHandler')
        event.preventDefault()
        event.stopImmediatePropagation()
        var formValid= document.querySelector('#mc--form').checkValidity()
        console.log('form is: '+formValid)
        if (formValid){
          subscribeHide()
          localStorage.setItem('mailChimpSubscribed', true);
          form.submit()
        }
    }

    function subscribeKeepItClosed() {
        sessionStorage.setItem('mailChimpClosed', true);
        var strDate=(new Date()).toJSON()
		localStorage.setItem('mailChimpClosedAt2', strDate);
    }
    function subscribeExpand(){
      var wrapper=document.querySelector('.subscribe--bg')
      if (wrapper) wrapper.classList.remove('subscribe--collapse')
    }

    function subscribeForce(){
      var wrapper=document.querySelector('.subscribe--bg')
      if (wrapper) { 
		wrapper.classList.remove('subscribe--collapse')
		wrapper.classList.add('subscribe--centered')
		wrapper.classList.remove('subscribe--hide')
		window.location.hash=''
	  }
    }



    function subscribeExpandHandler(){
      var button=document.querySelector('button#mc--form-expand')
      button.addEventListener('click', subscribeExpand, false)
    }

    function subscribeDisplay(){
      var wrapper=document.querySelector('.subscribe--bg')
      if (wrapper) wrapper.classList.remove('subscribe--hide')
    }

    function subscribeHide(){
      var wrapper=document.querySelector('.subscribe--bg')
      if (wrapper) wrapper.classList.add('subscribe--hide')
      subscribeKeepItClosed()
    }

    function subscribeCloseHandler(){
      var closeButton=document.querySelector('label.signup--close2')
      if (closeButton) closeButton.addEventListener('click',  subscribeHide, false)
    }

    function subscribeShow() {
        var notSubscribed = localStorage.getItem('mailChimpSubscribed') === 'true' ? false : true
        var notClosed = sessionStorage.getItem('mailChimpClosed') === 'true' ? false : true
        console.log(`not subscribed: ${notSubscribed}`)
        console.log(`not closed: ${notClosed}`)
        if (c_marketing && rightTime && notSubscribed && notClosed && !window.location.href.match(/pages/) ) {
            console.log('3rd stage')
            subscribeDisplay()
            subscribeExpandHandler()
            subscribeCloseHandler()
            var mcForm = document.querySelector('#mc--form')
            mcForm.addEventListener('submit', subscribeHandler, false)
        } else {
            //console.warn( "notSubscribed: " + notSubscribed + " notClosed: " + notClosed)
        }
    }


function checkForcedSubscribe(){
  if (window.location.hash==='#subscribe'){
			subscribeForce()
            subscribeCloseHandler()
            var mcForm = document.querySelector('#mc--form')
            mcForm.addEventListener('submit', subscribeHandler, false)

}
}


window.addEventListener('hashchange', checkForcedSubscribe, false);
checkForcedSubscribe()


    if ( !subscribeTypeButton) {
        window.addEventListener("load", function (event) {
            if (subscribeDelayTime) {
                window.setTimeout(subscribeShow, subscribeDelayTime)
            }
        })
    }
}
catch (err) {
    console.log(err)
}


  } catch(e) { console.error(e); }
})();
})();
